
export default {

    accountStatus: { 1: '正常',2:'冻结',3:'注销', 4:'审核中', 5:'审核拒绝' }, //成员状态

    isNot: { 1: '是',  0: '否' }, //

    dynamicType: { 1: '图片',  2: '视频',  3: '音频' }, //动态类型

    auditStatus: { 1: '审核中',  2: '审核通过',  3: '审核拒绝' }, //审核状态

    payStatus: { 1: '交易完成',  2: '交易失败',  3: '冻结' }, //钻石交易状态

    diamondType: { 1: '钻石充值',  2: '赠送礼物',  3: '续费装扮', 4:'帮好友代充', 5:'好友充值获得' }, //钻石交易类型

    specieType: { 1: '金币充值',  2: '赠送礼物',  3: '续费装扮', 4:'帮好友代充', 5:'好友充值获得' }, //金币交易类型

    activityType: { 1: '钻石充值活动',  2: '礼物收集活动' }, //活动分类

    activityStatus: { 1: '待开始',  2: '进行中',  3: '已结束' }, //活动状态

    sex: { 0: '保密', 1: '男', 2:'女' },

    anchorStatus: { 1: '正常', 2:'离职' },  //主播状态

    


    orderStatus: { 1: '待付款', 2:'计划未创建', 3:'计划已创建', 4:'待评价', 5:'已完成' },   //订单状态


    movementType: { 1: '组次',  2: '记时' }, //动作类型


    qiniuUploadUrl : 'https://upload-z1.qiniup.com',

    qiniuUrl: 'https://jiaolianqiniu.zhihuiapp.cn/',

    uploadUrl: '/system/upload/uploadList',


} 